import { render, staticRenderFns } from "./EmergencyContactsOverview.vue?vue&type=template&id=595d6c93&scoped=true"
import script from "./EmergencyContactsOverview.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsOverview.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContactsOverview.vue?vue&type=style&index=0&id=595d6c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d6c93",
  null
  
)

export default component.exports